import { render, staticRenderFns } from "./VideoGuides.vue?vue&type=template&id=68ea2726&scoped=true"
import script from "./VideoGuides.vue?vue&type=script&lang=js"
export * from "./VideoGuides.vue?vue&type=script&lang=js"
import style0 from "./VideoGuides.vue?vue&type=style&index=0&id=68ea2726&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ea2726",
  null
  
)

export default component.exports